class StaticTreeSource {
  constructor(data) {
    this.rootElements = [];
    this.childrenData = {};
    this.trailsData = {};
    this.rootElements = data;
    const walkTree = (children, trail) => {
      const parentId = trail[0] ? trail[0].id : null;
      if (parentId !== null) {
        this.childrenData[parentId] = [];
      }
      for (const child of children) {
        if (parentId !== null) {
          this.childrenData[parentId].push(child);
        }
        const childTrail = [child, ...trail];
        this.trailsData[child.id] = childTrail;
        if (child.children) {
          walkTree(child.children, childTrail);
        }
      }
    };
    walkTree(data, []);
  }
  children(id) {
    return Promise.resolve(id === null ? this.rootElements : this.childrenData[id] || []);
  }
  trail(id) {
    return Promise.resolve(this.trailsData[id] || []);
  }
}
const staticTreeSource = data => {
  return new StaticTreeSource(data);
};

export { staticTreeSource };
//# sourceMappingURL=StaticTreeSource.js.map
